/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class NavigationAccordionReadyDirective implements ng.IDirective {
        public restrict         : string    =   'EA';
        public replace          : boolean   =   false;
        public scope            : Object    =   {isReady: '@'};
        public transclude       : boolean   =   false;
        public templateUrl      : any       =   undefined;
        public static $inject   : string[]  =   [];
        public require          : string[]  =   ['^navigationAccordion'];

        constructor() {}

        public link : ng.IDirectivePrePost = {
            pre: function(scope : any,element : any,attrs : any,ctrl : any) {
                scope.$watch('isReady',function(newVal : any,oldVal : any) {
                    if (newVal) {
                        ctrl[0].showDefaultPage();
                    }
                });
            },
            post: function(scope,element,attrs,accordionNavigationController) {}
        }


        static factory(): ng.IDirectiveFactory {
            const directive = () => new NavigationAccordionReadyDirective();
            return directive;
        }

    }

    getDealerwareWebComponentsModule().directive("navigationAccordionReady", NavigationAccordionReadyDirective.factory());
}
